import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { CreateAlertSuccess } from '@app/+catalog/store/actions/catalog.action';

/**
 * On catalog page, when user creates a global alert.
 * => tracking payload is momentaly wrong. That's normal.
 * => we wait SEO tracking alert for "catalog page"
 */
const events = getEvents((action: CreateAlertSuccess) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'globalAlert',
      product_brand: '',
      product_category: '',
      product_univers: ''
    }
  },
  {
    type: 'Create an alert - productPage',
    container: TagContainer.Media
  }
]);

export default events;
